import { Injectable } from '@angular/core';
import { ApiService } from 'app/core/services/apiservice';
import { PlantillasResponse } from 'app/modules/admin/documentos-oficiales/models/plantillas.model';
import { CompletarGestionInteface } from './completar-gestion-sin-asociar-bien.model';

@Injectable({providedIn: 'root'})
export class CompletarGestionSinBienService {
    constructor(private apiService: ApiService) { }


    getPlantillas(seccion_uuid:number){
            const params= {seccion: seccion_uuid}
            const url=`/plantillas` 
            return new Promise((resolve, reject)=>{
                this.apiService.GetMethod(url, params, 'Error al obtener las plantillas.')
                    .subscribe((response: PlantillasResponse) => {
                        resolve(response.data)                    
                    }, error => {
                        reject(true)
                    })
            })
        }

    
    completargestionSinBien(body:CompletarGestionInteface){
            const url=`/gestion/finalizar_gestion_sin_asociar` 
            return new Promise((resolve, reject)=>{
                this.apiService.PostMethod(url, body, {}, 'Error al Completar Gestion.')
                    .subscribe((response: any) => {
                        resolve(response)                    
                    }, error => {
                        reject(true)
                    })
            })
        }
    
}
